import React, { memo } from 'react';

const GMButton = memo(({ type, className, onClick, isImage, image, text, disabled, style, imgStyle, tickLogo }) => {
    return (
        <>
            <button type={type} className={`${className}`} onClick={onClick} disabled={disabled} style={style}>
                {isImage && <img src={image} className="img-fluid" alt={text} style={imgStyle} />}

                {text}
                <img className="tick-icon" src={tickLogo}></img>
            </button>
        </>
    );
});

export default GMButton;
